import React from 'react';
import SvgIcon from './svgIcon';

const SvgBin = props => {
  return (
    <SvgIcon width="18.818" height="20.742" viewBox="0 0 18.818 20.742" {...props}>
      <path
        fill="none"
        d="M3 6h17.318"
        transform="translate(-2.25 -1.402)"
        style={{strokeLinecap:'round',strokeLinejoin:'round',strokeWidth:'1.5px'}}
      />
      <path
        fill="none"
        d="M18.47 5.848v13.47a1.924 1.924 0 0 1-1.924 1.924H6.924A1.924 1.924 0 0 1 5 19.318V5.848m2.886 0V3.924A1.924 1.924 0 0 1 9.811 2h3.848a1.924 1.924 0 0 1 1.924 1.924v1.924"
        transform="translate(-2.326 -1.25)"
        style={{strokeLinecap:'round',strokeLinejoin:'round',strokeWidth:'1.5px'}}
      />

    </SvgIcon>
  );
};

export default SvgBin;
